<template>
  <v-app-bar
    color="grey-darken-4"
    density="compact"
  >
    <!--
    <template #prepend>
      <v-app-bar-nav-icon />
    </template>
    -->

    <v-app-bar-title>
      <span class="text-body-1">My Web Radio</span>
    </v-app-bar-title>

    <v-spacer />

    <div class="cursor-pointer" style="cursor: pointer;">
      <v-text-field
        v-model="searchModel"
        :append-inner-icon="searchModel ? 'mdi-close' : ''"
        class="expanding-search"
        :class="{'closed': searchClosed && !searchModel}"
        density="compact"
        flat
        hide-details
        max-width="250"
        placeholder="Search"
        prepend-inner-icon="mdi-magnify"
        variant="solo-filled"
        :width="searchClosed && !searchModel ? 48 : 250"
        @click:append-inner="searchModel=''"
        @focusin="searchClosed = false"
        @focusout="searchClosed = true"
      />
    </div>

    <template #append>
      <v-btn
        class="ml-1"
        color="#333333"
        size="40"
        variant="flat"
        @click="toggleFavoritesFilter"
      >
        <v-icon :color="favoritesModel ? 'red' : 'white'" :icon="favoritesModel ? 'mdi-heart' : 'mdi-heart-outline'" />
      </v-btn>

      <v-btn
        class="ml-1"
        color="#333333"
        size="40"
        variant="flat"
        @click="toggleSortType"
      >
        <v-icon :icon="sortType === 'asc' ? 'mdi-sort-alphabetical-ascending' : 'mdi-sort-alphabetical-descending'" />
      </v-btn>

      <v-menu>
        <template #activator="{ props }">
          <v-btn
            class="ml-1"
            color="#333333"
            size="40"
            v-bind="props"
            variant="flat"
          >
            <v-icon icon="mdi-sort" />
          </v-btn>
        </template>

        <v-list v-model:selected="sortModel">
          <v-list-item
            v-for="(item, index) in sortItems"
            :key="index"
            :value="item.value"
          >
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </v-app-bar>
</template>

<script>
  import { mapWritableState } from 'pinia'
  import { useAppStore } from '@/stores/appStore.js'

  export default {
    name      : 'AppHeader',
    components: {},
    props     : {},
    data () {
      return {
        searchClosed: true,
        sortItems   : [
          { title: 'Name', value: 'name' },
          { title: 'Votes', value: 'votes' },
          { title: 'Trend', value: 'clicktrend' },
          { title: 'Change', value: 'lastchangetime' }
        ]
      }
    },
    computed: {
      ...mapWritableState(useAppStore, ['searchModel', 'sortModel', 'sortType', 'favoritesModel'])
    },
    watch  : {},
    created () {},
    mounted () {},
    beforeUnmount () {},
    unmounted () {},
    methods: {
      toggleFavoritesFilter () {
        this.favoritesModel = !this.favoritesModel
      },

      toggleSortType () {
        this.sortType = this.sortType === 'asc' ? 'desc' : 'asc'
      }
    }
  }
</script>

<style scoped>
.expanding-search {
  transition: width 0.25s;
}

:deep(.expanding-search.closed .v-input__control .v-field),
:deep(.expanding-search.closed .v-input__control .v-field__field input) {
  cursor: pointer !important;
}
</style>
